import type { Job } from '@/domains/jobs/components/JobCard';
import { GANTT_PRIORITY_BORDERS, GANTT_STATUS_COLORS } from './ganttJobBarStyles';

interface GanttMemberJobBarProps {
  job: Job;
  width: number;
  onJobClick?: (jobId: string) => void;
}

/** Read-only bar on a member's sub-row: no drag source; reschedule on the team bar. */
export function GanttMemberJobBar({ job, width, onJobClick }: GanttMemberJobBarProps) {
  return (
    <div
      data-testid="gantt-member-job-bar"
      data-job-id={job.id}
      role="button"
      tabIndex={0}
      className={`h-7 rounded cursor-pointer shadow-sm hover:shadow-md transition-all ${GANTT_STATUS_COLORS[job.status]} ${GANTT_PRIORITY_BORDERS[job.priority]}`}
      style={{ width: `${width}px` }}
      title={`${job.title} (Click to view details)`}
      onClick={() => onJobClick?.(job.id)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onJobClick?.(job.id);
        }
      }}
    >
      <div className="px-2 h-full flex items-center text-white text-xs overflow-hidden">
        <span className="font-semibold truncate">{job.title}</span>
      </div>
    </div>
  );
}
